import {
    NS_DOCUMENT_USER_KEY,
    NS_QDABRA_WEBSERVICE,
} from '../helpers/dbxl.helpers';
import webServiceWrapper from './webServiceWrapper';

const nses = {
    qws: NS_QDABRA_WEBSERVICE,
    quk: NS_DOCUMENT_USER_KEY,
};

function getDocumentWrapper(dataSource, dataConnection) {
    const wswrap = webServiceWrapper(dataSource, dataConnection, nses, [
        'GetDocument',
        'GetDocumentVersion',
    ]);

    const docInfoNode = () =>
        wswrap.getServiceElement(wswrap.responseNode(), 'docInfo');

    const contentNode = () =>
        wswrap.getServiceElement(docInfoNode(), 'Content');

    return {
        docId: (value) => {
            wswrap.setQueryField('docId', value);
        },
        version: (value) => {
            wswrap.setQueryField('version', value);
        },
        resultNode: wswrap.resultNode,
        successNode: () =>
            wswrap.getServiceElement(wswrap.resultNode(), 'Success'),
        docInfoNode: docInfoNode,
        contentNode: contentNode,
        documentRoot: () => wswrap.selectNode(contentNode(), '*'),
        name: () => wswrap.getServiceElementValue(docInfoNode(), 'Name'),
        author: () => wswrap.getServiceElementValue(docInfoNode(), 'Author'),
        description: () =>
            wswrap.getServiceElementValue(docInfoNode(), 'Description'),
        executeAsync: async () => {
            await wswrap.executeAsync();
        },
    };
}

export default getDocumentWrapper;
